import { DatePipe } from '@angular/common';
import {NgModule} from '@angular/core';
import {DatePipeTz} from './date-pipe-tz.pipe';
import {JoinPipe} from './join.pipe';
import {ToSelectSearchDropdownOptions} from './to-select-search-dropdown-options.pipe';

@NgModule({
  declarations: [DatePipeTz, JoinPipe, ToSelectSearchDropdownOptions],
  exports: [DatePipeTz, JoinPipe, ToSelectSearchDropdownOptions],
  providers: [
    {
      provide: DatePipe,
      useClass: DatePipeTz
    },
    {
      provide: ToSelectSearchDropdownOptions,
      useClass: ToSelectSearchDropdownOptions
    }
  ]
})
export class CommonDirectivesModule {}
